import React from 'react';
import Immutable from 'immutable';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Paragraph } from '@uncinc/react-drupal-core';

import type { ParagraphActivities as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphActivitiesProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphActivities: React.FC<ParagraphActivitiesProps> = ({
  entity,
}) => {
  const activities = entity.toJS();
  const uuid = activities.uuid[0].value;
  const title = activities.field_title?.[0]?.value || '';
  const activityItems = activities.field_paragraphs;

  return (
    <div id={uuid} className="ParagraphActivities">
      <Container>
        {title && <h2>{title}</h2>}
        {activityItems.map(({ target_id: id, entity: paragraph }) => (
          <Paragraph key={id} id={id} entity={Immutable.Map(paragraph)} />
        ))}
      </Container>
    </div>
  );
};

export default ParagraphActivities;
